<template>
	<div class="transfer">
	    <van-nav-bar class="header" title="转化为商机" left-arrow @click-left="onClickLeft" fixed/>
	    <div class="form-box">
			<van-cell-group>
				<van-field class="transferField" v-model="name" label="商机名称" required />
				<van-field-acb class="transferField" v-model="company" dict="crm_customer"
				               label="客户名称" :required="true" :readonly="isCompanyReadonly" />
				<van-field-acb class="transferField" v-model="stage" dict="dict_sale_chance_stage"
				               label="联系阶段" :required="true" />
				<van-field class="transferField" v-model="amount" label="预计金额(万元)" />
				<van-field class="transferField" label="联系人" v-model="contacts" readonly />
				<van-field class="transferField" label="联系电话" v-model="mobile" readonly />
				<van-field-acb class="transferField" v-model="creator" dict="base_staff"
				               label="线索提供人" :readonly="true" />
				<van-field-acb class="transferField" v-model="department" dict="dict_crm_sale_chance_业务主责部门"
				               label="业务主责部门" />
				<van-field class="transferField" label="备注" v-model="remark" />
			</van-cell-group>
	    </div>
		<van-button type="primary" size="large" @click="save">确 定</van-button>
	</div>
</template>

<script>
	import {NavBar,Button,Toast,Field,Cell,CellGroup} from 'vant';
	import VanFieldAcb from '../components/VanFieldAcb';
	import threadService from "../service/threadService";
	export default {
		data() {
			return {
				clue: {},
				name: '',
				company: '',
				stage: '',
				amount: '',
				contacts:'',
				mobile:'',
				creator:'',
				department:'',
				remark:'',
				isCompanyReadonly:false
			};
		},
		components: {
			VanFieldAcb,
		    [NavBar.name]: NavBar,
			[Button.name]: Button,
			[Field.name]: Field,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[VanFieldAcb.name]: VanFieldAcb,
		},
		mounted:function() {
			console.log(this.$route.query.clue)
		    this.clue = this.$route.query.clue;
			this.company = this.clue.customerId;
			this.contacts = this.clue.contactPer;
			this.mobile = this.clue.mobile;
			this.creator = this.clue.creatorId;
			if (this.clue.customerId) {
				this.isCompanyReadonly = true;
			}
		},
		methods:{
			async save() {
				if(this.clue.name == '') {
					Toast.fail('请填写商机名称');
					return;
				}
				if(this.clue.company == '') {
					Toast.fail('请填写客户名称');
					return;
				}
				if(this.clue.stage == '') {
					Toast.fail('请填写联系阶段');
					return;
				}
				let resp = await threadService.transfer(this.clue.uuid,this.name, this.company, this.stage, this.amount,
				    this.department, this.remark);
				if (resp.data.Status === "1") {
				   Toast.success('转化成功');
				   let that = this;
				   setTimeout(function(){
					   that.$router.push({path:"Thread"})
				   },2000)
				}
			},
		    onClickLeft() {
		        this.$router.go(-2);
		    },
		}
	}
</script>

<style>
.form-box {
        margin-top: 120px;
    }
	.transfer .transferField>.van-cell__title,.transfer .transferField>.van-cell>.van-cell__title {
		text-align: right;
		margin-right:1rem;
		width: 100px !important;
		}
	.transfer .van-cell--required::before {
		left:117px !important;
	}
</style>
